import Image from 'next/image';

import { IImageType } from '@/src/types';

type IProps = {
  desktop: IImageType | null;
  mobile: IImageType | null;
};

export const DestinationDetailsImage = ({ desktop, mobile }: IProps) => {
  return (
    <div className={'relative shrink-0 md:w-[370px] lg:w-[400px] xl:w-[467px]'}>
      {desktop && (
        <Image
          placeholder={'blur'}
          blurDataURL={'/static/images/placeholder.webp'}
          src={desktop.image}
          alt={desktop.alt || ''}
          objectFit="cover"
          fill
          priority
          loading={'eager'}
          className={
            'hidden max-h-[813px] w-full rounded-2xl object-cover md:block'
          }
        />
      )}
      {mobile && (
        <Image
          placeholder={'blur'}
          blurDataURL={'/static/images/placeholder.webp'}
          src={mobile.image}
          alt={mobile.alt || ''}
          priority
          loading={'eager'}
          width={400}
          height={200}
          className={'block w-full shrink-0 rounded-2xl md:hidden'}
        />
      )}
    </div>
  );
};
